import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
 * @file Dialog
 * @author alfielv
 */
import _ from 'lodash';
import React, { useState, useRef } from 'react';
import { Dialog as SPAUIDialog } from '@tencent/spaui';
import { PREFIX_CLS } from '../../constants';
import message from '../Message';
var prefixCls = "".concat(PREFIX_CLS, "-dialog");
;

var Dialog = function Dialog(props) {
  var dialogOptions = props.dialogOptions,
      show = props.show,
      hideDialog = props.hideDialog;
  var config = dialogOptions.config,
      body = dialogOptions.body,
      payload = dialogOptions.payload,
      onSuccess = dialogOptions.onSuccess,
      onCancel = dialogOptions.onCancel,
      wrappedComponent = dialogOptions.wrappedComponent,
      content = dialogOptions.content,
      _dialogOptions$closeB = dialogOptions.closeBySuccess,
      closeBySuccess = _dialogOptions$closeB === void 0 ? true : _dialogOptions$closeB;

  var onSubmitFromConfig = config.onSubmit,
      onCancelFromConfig = config.onCancel,
      onCloseFormConfig = config.onClose,
      dialogProps = _objectWithoutProperties(config, ["onSubmit", "onCancel", "onClose"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var mainRef = useRef(null); // 主体区域ref

  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, hideCallback) {
      var _ref2, wrappendSubmitCb;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.prev = 1;
              onSubmitFromConfig === null || onSubmitFromConfig === void 0 ? void 0 : onSubmitFromConfig(event, hideCallback); // WrappedComponent内部抛出

              _ref2 = mainRef.current || {}, wrappendSubmitCb = _ref2.onSubmit;
              _context.next = 6;
              return wrappendSubmitCb === null || wrappendSubmitCb === void 0 ? void 0 : wrappendSubmitCb();

            case 6:
              _context.t0 = onSuccess;

              if (!_context.t0) {
                _context.next = 10;
                break;
              }

              _context.next = 10;
              return onSuccess(mainRef.current);

            case 10:
              closeBySuccess && hideDialog();
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t1 = _context["catch"](1);

              if (_context.t1 !== null && _context.t1 !== void 0 && _context.t1.message) {
                message.error(_context.t1.message);
              }

            case 16:
              setLoading(false);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 13]]);
    }));

    return function handleSubmit(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleCancel = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event, hideCallback) {
      var _ref4, wrappendCancelCb;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              onCancelFromConfig === null || onCancelFromConfig === void 0 ? void 0 : onCancelFromConfig(event, hideCallback); // WrappedComponent内部抛出

              _ref4 = mainRef.current || {}, wrappendCancelCb = _ref4.onCancel;
              _context2.next = 4;
              return wrappendCancelCb === null || wrappendCancelCb === void 0 ? void 0 : wrappendCancelCb();

            case 4:
              // 调用侧回调
              onCancel === null || onCancel === void 0 ? void 0 : onCancel(mainRef.current);
              hideDialog();

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleCancel(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleClose = function handleClose(event, hideCallback) {
    onCloseFormConfig === null || onCloseFormConfig === void 0 ? void 0 : onCloseFormConfig(event, hideCallback);
    onCancel === null || onCancel === void 0 ? void 0 : onCancel(mainRef.current);
    hideDialog();
  };

  var main = function () {
    var _WrappedComponent$$$t, _WrappedComponent$$$t2;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    var WrappedComponent = body || wrappedComponent || content; // ForwardRef包装的组件

    if (_.isPlainObject(WrappedComponent) && WrappedComponent.render && ((_WrappedComponent$$$t = WrappedComponent.$$typeof) === null || _WrappedComponent$$$t === void 0 ? void 0 : _WrappedComponent$$$t.description) === 'react.forward_ref') {
      return /*#__PURE__*/React.createElement(WrappedComponent, {
        ref: mainRef,
        payload: payload
      });
    } // 函数组件、类组件声明
    // 组件声明的高阶包装，React.memo，以及react-redux connect（也会包裹react.memo）


    if (_.isFunction(WrappedComponent) || _.isPlainObject(WrappedComponent) && ((_WrappedComponent$$$t2 = WrappedComponent.$$typeof) === null || _WrappedComponent$$$t2 === void 0 ? void 0 : _WrappedComponent$$$t2.description) === 'react.memo') {
      return /*#__PURE__*/React.createElement(WrappedComponent, {
        payload: payload
      });
    } // 直接返回


    return WrappedComponent;
  }();

  return /*#__PURE__*/React.createElement(SPAUIDialog, _extends({
    className: prefixCls,
    useNewUI: true,
    show: show,
    backdrop: true,
    enabledBackdropClose: false,
    onClose: handleClose,
    onSubmit: handleSubmit,
    onCancel: handleCancel,
    loading: loading
  }, dialogProps), main);
};

export default Dialog;